import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { transientOptions } from "shared/lib/styles";

import ImageOvalBg from "./img-oval-background.svg";

const ovalBackgroundStyle = css`
  display: block;

  inline-size: 100%;
  block-size: auto;
`;

type OvalBackgroundProps = {
  $ovalFillColor: string;
  $rectFillColor: string;
};

export const OvalUpperBackground = styled(ImageOvalBg, {
  ...transientOptions,
})<OvalBackgroundProps>(
  props => css`
    ${ovalBackgroundStyle}
    margin-block-start: -1px;

    ${props.$rectFillColor &&
    css`
      path:first-child {
        fill: ${props.$rectFillColor};
      }
    `}

    ${props.$ovalFillColor &&
    css`
      path:nth-child(2) {
        fill: ${props.$ovalFillColor};
      }
    `}
  `,
);

export const OvalBottomBackground = styled(ImageOvalBg, {
  ...transientOptions,
})<OvalBackgroundProps>(
  props => css`
    ${ovalBackgroundStyle}
    margin-block-end: -1px;

    transform: rotate(180deg);

    ${props.$rectFillColor &&
    css`
      path:first-child {
        fill: ${props.$rectFillColor};
      }
    `}

    ${props.$ovalFillColor &&
    css`
      path:nth-child(2) {
        fill: ${props.$ovalFillColor};
      }
    `}
  `,
);
